// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CreateMasterInvoiceResponseFragment } from '../../fragments/generated/create-master-invoice-response.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateMasterInvoiceMutationVariables = Types.Exact<{
  linkedReceiptIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  upsertInvoiceDTO: Types.UpsertInvoiceDtoInput;
}>;


export type CreateMasterInvoiceMutationResult = { __typename?: 'Mutation', createMasterInvoice: { __typename?: 'CreateMasterInvoiceResponseDTO', invoiceId: number, bolloRequired: boolean } };

export const CreateMasterInvoiceGql = gql`
    mutation CreateMasterInvoice($linkedReceiptIds: [Int!]!, $upsertInvoiceDTO: UpsertInvoiceDTOInput!) {
  createMasterInvoice(
    linkedReceiptIds: $linkedReceiptIds
    upsertInvoiceDTO: $upsertInvoiceDTO
  ) {
    ...CreateMasterInvoiceResponse
  }
}
    ${CreateMasterInvoiceResponseFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMasterInvoiceInjectable extends Apollo.Mutation<CreateMasterInvoiceMutationResult, CreateMasterInvoiceMutationVariables> {
    override document = CreateMasterInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */